<template>
  <v-skeleton-loader
    :loading="loading"
    type="table"
  >
    <v-card>
      <v-card-title>
        <h2 class="text-h3">
          {{ $t('statisticsStrings.approvalsByMonth.panelHeader') }}
        </h2>
      </v-card-title>
      <v-card-text>
        <v-table>
          <thead>
            <tr>
              <th>{{ $t('statisticsStrings.approvalsByMonth.tableHeaders.month') }}</th>
              <template
                v-for="config in integrationConfigs"
                :key="config.id"
              >
                <th>
                  {{ $t("statisticsStrings.approvalsByMonth.tableHeaders.count", [config.name]) }}
                </th>
                <th>
                  {{ $t("statisticsStrings.approvalsByMonth.tableHeaders.yearAccumulatedTotal", [config.name]) }}
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in descendingTableContents"
              :key="item.month"
            >
              <td>{{ createDateFromMonthAndYear(item.month, item.year).format($t("commonStrings.monthYearDisplayFormat")) }}</td>
              <template
                v-for="config in integrationConfigs"
                :key="config.id"
              >
                <td>
                  {{ replaceZeroAndNullValues(getCountByApplicationId(item, config.applicationId), "-") }}
                </td>
                <td>
                  {{ replaceZeroAndNullValues(getAccumulatedTotalInYear(item, index, config.applicationId), "-") }}
                </td>
              </template>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import { api } from "@/utils/api";
import { copy } from "@/utils/object";
import { replaceZeroAndNullValues } from "@/utils/numeric";
import { createDateFromMonthAndYear, sortByYearThenMonthAscending, sortByYearThenMonthDescending } from "@/utils/date";
import { handleError } from "@/utils/errorHandler";
import { m } from '@/plugins/moment';

export default {
  name: "ApprovalsByMonthPanel",
  setup() {
    return { m, replaceZeroAndNullValues };
  },
  data() {
    return {
      loading: true,
      tableContents: [],
      integrationConfigs: []
    };
  },
  computed: {
    ascendingTableContents() {
      return copy(this.tableContents).sort(sortByYearThenMonthAscending);
    },
    descendingTableContents() {
      return copy(this.tableContents).sort(sortByYearThenMonthDescending);
    }
  },
  async mounted() {
    await this.fetch();
  },
  methods: {
    async fetch() {
      try {
        const response = await api.v1.statistics.approvalCountsByFunctionalityIdAndMonth();
        if (response.status === 200) {
          this.tableContents = response.data;
        }

        const integrationsResponse = await api.v1.integrationConfigurations.get();
        if (integrationsResponse.status === 200) {
          this.integrationConfigs = integrationsResponse.data;
        }
      } catch (error) {
        await handleError(error);
      }

      this.loading = false;
    },
    getCountByApplicationId(item, applicationId) {
      const functionalityIdItem = item.functionalityIdAggregates.find(x => x.functionalityId === applicationId);

      if (functionalityIdItem) {
        return functionalityIdItem.count;
      }

      return 0;
    },
    getAccumulatedTotalInYear(item, index, applicationId) {
      const subArray = this.getAccumulatedTotalItems(index);
      const filteredSubArray = subArray.filter(x => x.year === item.year);

      if (filteredSubArray?.length) {
        return filteredSubArray.reduce((acc, cur) => acc + this.getCountByApplicationId(cur, applicationId), 0);
      }

      return 0;
    },
    getAccumulatedTotalItems(index) {
      if (this.ascendingTableContents) {
        return this.ascendingTableContents.slice(0, this.ascendingTableContents.length - index);
      }

      return [];
    },
    createDateFromMonthAndYear
  }
};
</script>